// Fonts self-hostées via @fontsource (RGPD : zéro appel Google Fonts US au chargement).
// Poids = exactement ceux du <link> retiré d'index.html (Lato 400/700/900, Raleway
// 400/500/600/700, EB Garamond 500/600 + italique 500).
import '@fontsource/eb-garamond/500-italic.css';
import '@fontsource/eb-garamond/500.css';
import '@fontsource/eb-garamond/600.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';

const racine = document.getElementById('root');
if (!racine) throw new Error('Élément #root introuvable');
createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
